import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
@Component({
  selector: 'app-cheque-clear-popup',
  templateUrl: './cheque-clear-popup.component.html',
  styleUrls: ['./cheque-clear-popup.component.scss']
})
export class ChequeClearPopupComponent implements OnInit {
  cheque_data = null;
  transaction_id = null;
  approved_on = null;
  constructor(public dialogRef: MatDialogRef<ChequeClearPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: {}, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.cheque_data = data
  }
  saveApproval() {
    if (this.transaction_id == null || this.approved_on == null) {
      alert('fill all details');
      return false
    }
    let data_dict = {
      transaction_id: this.transaction_id,
      approved_on: this.approved_on,
      transaction_log_id:this.cheque_data['id'],
      agent_id: this.cheque_data['agent_profile_id']

    }
    this.http.saveApproval(data_dict).subscribe((data)=> {
      console.log(data);
      this.global.showSnakeBar('check approved')
      this.close()
    }, (error)=> {
      console.error(error);
    })
  }

  close() {
    let data = true;
    this.dialogRef.close(data);
  }

  ngOnInit() {
  }

}
